export class ADALModel{
    Name: string;
    Token: string;
    public Email:string;
    ADObject: any;
    ExpiresOn: string;
}
